import React, { useState, useEffect } from "react";
import axios from "axios";
import { Star } from "lucide-react";
import { PageHero } from "../components/PageHero";
import { AIContent } from "../components/AIContent";
import { T } from "../context/LanguageContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function HallOfFamePage() {
  const [inductees, setInductees] = useState([]);

  useEffect(() => {
    axios.get(`${API}/halloffame`).then((r) => setInductees(r.data)).catch(() => {});
  }, []);

  return (
    <div>
      <PageHero topic="gold trophy award ceremony" title="Halls of Fame & Sporting History" subtitle="Honoring athletes, coaches, officials and builders — with documented eligibility, selection bodies and official citations." listenTargetId="page-content" />
      <div id="page-content" className="mx-auto max-w-7xl space-y-10 px-4 py-12 sm:px-6">
        <AIContent topic="Why halls of fame matter — preserving sporting memory with dignity and evidence" context="Editorial on halls of fame, community honor boards, nomination processes and documenting difficult history responsibly." />
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3" data-testid="halloffame-grid">
          {inductees.map((h) => (
            <div key={h.id} data-testid={`hof-card-${h.id}`} className="relative overflow-hidden rounded-2xl border border-slate-200 bg-white p-6 shadow-sm transition-all hover:-translate-y-1 hover:shadow-lg">
              <div className="absolute -right-4 -top-4 h-20 w-20 rounded-full bg-amber-100/60" />
              <div className="relative flex items-start justify-between">
                <span className="flex h-11 w-11 items-center justify-center rounded-full bg-amber-500 text-white"><Star className="h-5 w-5" /></span>
                <span className="rounded-full bg-slate-100 px-2.5 py-1 text-[10px] font-bold uppercase text-slate-600"><T>{h.category}</T></span>
              </div>
              <h3 className="relative mt-3 text-lg font-bold text-slate-900">{h.name}</h3>
              <p className="text-xs font-semibold text-slate-400">{h.sport} · {h.country}</p>
              <p className="mt-3 text-sm italic leading-relaxed text-slate-600">“<T>{h.citation}</T>”</p>
              <div className="mt-4 border-t border-slate-100 pt-3 text-xs text-slate-500">
                <p><span className="font-bold"><T>Hall</T>:</span> {h.hall}</p>
                <p className="mt-1"><span className="font-bold"><T>Inducted</T>:</span> {h.inducted}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
